module.exports = __webpack_public_path__ + "img/default_profile.906ee4c.png";